import { AxiosInstances as AxiosInstance} from './BaseService'

export default {
    getAllSetupSchool: () =>
        AxiosInstance({
            'method': 'GET',
            'url': '/SetupSchool'
        })
}